export default __webpack_public_path__ + "static/media/left.cb2f5b85.svg";